import { createFileRoute } from '@tanstack/react-router';
import { GoalsRoute } from './-goals-route';

/**
 * Everything below `/journeys/goals` — `/new`, `/:goalId`, `/:goalId/milestones`
 * and any deeper URL the embedded app serves — so the flag gate covers the whole
 * subtree rather than the index alone.
 */
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/$')({
  component: GoalsRoute,
});
